/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'water': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M32 8c0 7.226-6 7.645-6 18.14v2.36M16 8c0 7.226-6 7.645-6 18.14v9.36M44 8c0 7 5.5 7.5 5.5 17.666V53a5 5 0 01-5 5H31a5 5 0 01-5-5V35" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M28 8c0 2.719.83 4.457 1.845 6.162M26 58H15a5 5 0 01-5-5V35M41 28h8M44 33h5" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="2" _stroke="#000230" stroke-width="2" d="M24 4v6M40 4v6M20 4v6M36 4v6M26 23h23M10 23h13M26 43h23M10 43h13M26 38h23M10 38h13M26 53h23M10 53h13M26 48h23M10 48h13M32 5a2 2 0 012-2h8a2 2 0 012 2v5H32V5zM16 5a2 2 0 012-2h8a2 2 0 012 2v4a1 1 0 01-1 1H17a1 1 0 01-1-1V5zM26 30v2"/>'
  }
})
